<template>
    <div class="order_list">
        <headerimg></headerimg>
        <div class="oderlist">
            <div class="listcontent">
                <h2>Authorise payment</h2>
                <div class="words">
                    <p>Please ensure you have your phone with you and sufficient balance in your account. We will send a prompt to <span class="weight_point">{{List.mobile}}. </span>Enter your PIN to authorize your payment of <span class="weight_point">KES {{List.amount}}</span>to account number <span class="weight_point">{{List.transferBank}}. </span></p>

                </div>
                <div class="img">
                    <img src="../../assets/images/mpesa/icon1.png" alt="">
                </div>
                <div class="tips">Click <span>Send Prompt </span>when ready.</div>
            </div>
            <div class="grounp_btn_mpesa">
                <div class="mpesa_btn_left" @click="$router.go(-1)">Back</div>
                <div class="mpesa_btn_right" @click="payment">{{btntext}}</div>
            </div>
        </div>

        <emailtext></emailtext>
    </div>
</template>
<script>
export default {
    data(){
        return {
          List: {
          	mobile:'',
          	email:''
          },
          Params:'',
          request_flag: true,
          btntext:'Send Prompt'
        }
    },
    components:{

    },
    mounted() {
      this.getParams()
      // this.payment()s
      this.Params = this.$route.query
    },
    methods:{
      getParams() {
          this.List = this.$route.query
      console.log(this.$route)
      console.log(this.List)
        },
        gotopayment(){
          this.$router.push({path:'/mpesa/processing',query:this.Params})
        },
      payment() {
          console.log(this.List)
          if (!this.request_flag) {
            return
          }
          this.btntext='Loading...'
          // this.$toast('Payment Proceed')
          this.payBtn = "Payment Proceed";
          const that = this;
          this.request_flag = false
          this.flag = true // 加载中...
          // const sign = localStorage.getItem('sign')
          const timestamp = new Date().getTime()
          const curURL = '/api/order/submitSecond'
      		const data ={
      			merchantId:that.List.merchantId,
      			merchantOrderId:that.List.merchantOrderId,
      			amount:that.Params.amount,
      			timestamp:timestamp,
      			sign:that.List.sign,
      			mobile:that.List.mobile,
      			email:that.List.email
      		}

          this.axios.post(curURL,data).then(res => {
            console.log(res.data.data.status)
            if (res.data.data.status == 0) {
              // 待支付
              this.flag = false
              this.$toast('Your money will be comfirmed in few minutes')
              this.$router.push({path:'/mpesa/processing',query:this.Params})
            } else if (res.data.data.status == 1) {
              // this.$toast('Payment success')
              // this.$router.push({path: '/success', query: {'image': this.UserInfo.logoUrl}})
              if(res.data.data.callbackUrl!='' && res.data.data.callbackUrl.startsWith('http')){
              	window.location.href=res.data.data.callbackUrl
              }else{
                  this.$router.push({path: '/mpesa/success', query: this.Params})
              }

            } else if (res.data.data.status == 2) {
              // this.$toast('Failure to pay')
              this.$router.push({path: '/mpesa/fail', query: this.Params})
            }
            this.request_flag = true
            this.btntext='Send Prompt'
          })
        },
    },

}
</script>grounp_btn_mpesa
<style lang="scss" scoped>
.oderlist{
    padding: 0 0.48rem;
    .listcontent{
        background: #FFFFFF;
        border-radius: 0.32rem;
        h2{
            font-size: 0.4rem;
            font-weight: 800;
            color: #39B549;
            line-height: 0.66rem;
            padding: 0.8rem 0 0.16rem 0;
        }
        .words{
            font-size: 0.28rem;
            font-weight: 500;
            color: #151515;
            line-height: 0.42rem;
            text-align: left;
            padding:0 0.68rem;
            .weight_point{
                font-weight: bold;
            }
        }
        .img{
            margin: 0.7rem 0;
            img{
                width: 4.26rem;
                margin: 0 auto;
            }


        }
        .tips{
            font-size: 0.28rem;
            font-weight: 500;
            color: #151515;
            line-height: 0.5rem;
            padding-bottom: 0.56rem;
            span{
                font-weight: bold;
            }
        }
    }
}
.grounp_btn_mpesa{
    margin: 0.32rem 0;
    display: flex;
    justify-content: space-between;
    line-height: 1rem;
    font-size: 0.3rem;
    font-weight: 800;
    .mpesa_btn_left{
        width: 2rem;
        height: 1rem;
        background: #191932;
        border-radius: 0.16rem;
        color: #FFFFFF;

    }
    .mpesa_btn_right{
        width: 4.24rem;
        height: 1rem;
        background: linear-gradient(133deg, #02BD60 0%, #02B683 32%, #00B39B 100%), linear-gradient(138deg, #8AFFA7 0%, #FEFD42 100%);
        border-radius: 0.16rem;
        color: #151515;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/mpesa/order.vue